module.exports = __webpack_public_path__ + "media/images/exclamation-a19077b4493094a7b57505cc8ae1dd70.svg";